export default __webpack_public_path__ + "locales/pt-BR/PreparationPortal.json?hash=b7ea39ce7efc93e8f5ef8360123a2318";